export default __webpack_public_path__ + "static/contact-us-m-3ff9abeeb46fb2e43b083776ec606efd.png";